<template>
  <div class="clue-follow">
    <Back title="备注跟进"></Back>
    <main>
      <van-form @submit="onSubmit">
        <van-field v-model="content" name="content" :rules="[required]" rows="4" autosize label="备注信息" type="textarea"
          maxlength="200" placeholder="请输入备注信息" show-word-limit clearable required />
        <!-- 图片上传 -->
        <div class="upload">
          <p>图片上传</p>
          <van-uploader v-model="fileList" multiple :max-count="maxCount" :after-read="afterRead" />
        </div>
        <div style="margin: 16px;">
          <van-button round block type="info" native-type="submit">提交</van-button>
        </div>
      </van-form>
    </main>
  </div>
</template>

<script>
import Back from "@/components/back";
import { Toast } from "vant";
import {
  objToOpt,
} from "@/utils/utils"
import OSS from "ali-oss";
import Exif from "exif-js";
import { getSaveRemark } from "@/api/clue/clue";
import { getUploadToken, getFileId } from "@/api/common/common";
import { required } from "@/utils/rules"
export default {
  components: { Back },
  data() {
    return {
      objToOpt,
      required,
      clueId: this.$route.query.clueId,
      content: '',
      fileList: [],
      remarkFiles: "",
    };
  },
  computed: {
    maxCount() {
      console.log('this.fileList.length: ', this.fileList.length);
      return 9 - this.fileList.length;
    }
  },
  methods: {
    // 【监听】图片上传
    afterRead(files) {
      if (!files.length) { files = [files] }
      for (let i of files) {
        this.upload(i)
      }
    },

    // 上传
    upload(file) {
      let _this = this;
      file.status = "uploading";
      file.message = "上传中...";
      getUploadToken().then((res) => {
        const { accessKeyId, accessKeySecret, securityToken } =
          res.data.credentials;
        const client = new OSS({
          accessKeyId,
          accessKeySecret,
          stsToken: securityToken,
          bucket: "static-eastecp-com", //存储空间名称
          region: "oss-cn-hangzhou", //申请oss服务时的区域
        });

        //去获取拍照时的信息，解决拍出来的照片旋转问题
        const Orientation = "";
        Exif.getData(file, function () {
          Orientation = Exif.getTag(this, "Orientation");
        });

        const File = file.file;
        const reader = new FileReader();
        reader.readAsDataURL(File);
        reader.onload = function () {
          const image = new Image();
          image.src = this.result;
          image.onload = function () {
            const canvas = document.createElement("canvas");
            const context = canvas.getContext("2d");
            // 图片原始尺寸
            const originWidth = this.width;
            const originHeight = this.height;
            // 最大尺寸限制
            const maxWidth = 480;
            const maxHeight = 640;
            let targetWidth = originWidth;
            let targetHeight = originHeight;
            if (originWidth > maxWidth && originHeight > maxHeight) {
              targetWidth = maxWidth;
              targetHeight = maxHeight;
            } else if (originWidth > maxWidth && originHeight < maxHeight) {
              targetWidth = originHeight;
              targetHeight = originHeight;
            } else if (originWidth < maxWidth && originHeight > maxHeight) {
              targetWidth = originWidth;
              targetHeight = originWidth;
            }

            // 图片压缩旋转
            canvas.width = targetWidth;
            canvas.height = targetHeight;
            context.clearRect(0, 0, targetWidth, targetHeight); // 清除画布
            switch (Orientation) {
              case "":
                context.drawImage(image, 0, 0, targetWidth, targetHeight);
                break;
              case 1:
                context.drawImage(image, 0, 0, targetWidth, targetHeight);
                break;
              case 3: //需要180度旋转
                context.rotate(Math.PI);
                context.drawImage(
                  image,
                  -targetWidth,
                  -targetHeight,
                  targetWidth,
                  targetHeight
                );
                break;
              case 6: //需要顺时针（向左）90度旋转
                canvas.width = targetHeight;
                canvas.height = targetWidth;
                context.rotate(Math.PI / 2);
                context.drawImage(
                  image,
                  0,
                  -targetHeight,
                  targetWidth,
                  targetHeight
                );
                break;
              case 8: //需要逆时针（向右）90度旋转
                canvas.width = targetWidth;
                canvas.height = targetHeight;
                context.rotate((3 * Math.PI) / 2);
                context.drawImage(
                  image,
                  -targetWidth,
                  0,
                  targetWidth,
                  targetHeight
                );
                break;
              default:
                context.drawImage(image, 0, 0, targetWidth, targetHeight);
            }

            const type = "image/jpeg";
            //将canvas元素中的图像转变为DataURL
            const dataurl = canvas.toDataURL(type);
            //抽取DataURL中的数据部分，从Base64格式转换为二进制格式
            const bin = atob(dataurl.split(",")[1]);
            //创建空的Uint8Array
            const buffer = new Uint8Array(bin.length);
            //将图像数据逐字节放入Uint8Array中
            for (let i = 0; i < bin.length; i++) {
              buffer[i] = bin.charCodeAt(i);
            }

            // 图片上传
            let fileName =
              _this.random_string(6) +
              "_" +
              new Date().getTime() +
              "." +
              File.name.split(".").pop();
            let date = (new Date().toLocaleDateString() + "").replace(
              /\//g,
              ""
            );
            let blob = new Blob([buffer.buffer], { type }); //利用Uint8Array创建Blob对象
            client
              .multipartUpload("upload/" + date + "/" + fileName, blob, {
                progress: function (percentage) {
                  if (percentage) {
                    file.status = "done";
                    file.message = "上传成功";
                  }
                },
              })
              .then((res) => {
                let url =
                  "https://static-eastecp-com.oss-cn-hangzhou.aliyuncs.com/" +
                  res.name;
                getFileId(url).then(function (res) {
                  if (res.success) {
                    file.fileId = res.data;
                    file.url = url;
                    Toast("上传成功");
                  }
                });
              })
              .catch(() => {
                file.status = "failed";
                file.message = "上传失败";
                Toast(file.message);
              });
          };
        };
      });
    },


    // 【函数】随机生成文件名
    random_string(len) {
      len = len || 10;
      let chars = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678";
      let maxPos = chars.length;
      let pwd = "";
      for (let i = 0; i < len; i++) {
        pwd += chars.charAt(Math.floor(Math.random() * maxPos));
      }
      return pwd;
    },

    // 【监听】提交
    onSubmit() {
      let data = {
        clueId: this.clueId,
        content: this.content,
        remarkFiles: this.fileList.map(i => i.fileId).toString()
      }
      getSaveRemark(data).then(res => {
        if (res.success) {
          Toast(res.msg);
          this.$router.push("/clue/clueInfo?clueId=" + this.clueId);
        }
      })
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/theme';

.clue-follow {
  height: 100%;
  display: flex;
  flex-direction: column;
}

main {
  flex: 1;
  overflow: auto;
}

.upload {
  padding: 0.05rem 0.06rem;

  p {
    font-size: 0.14rem;
    padding: 0 0.1rem;
    color: #646566;
  }

  .van-uploader {
    margin: 0.1rem;
  }
}
</style>